import React from 'react';
import './index.module.less';
import { SettingItemInfo } from './index.d';

interface IProps {
  info: SettingItemInfo;
}

const SettingItem = (props: IProps) => {
  const { info } = props;
  const containerStyle = info.hideBorder ? 'container no-border' : 'container';

  return<div styleName={containerStyle} onClick={info.disable ? null : info.itemClick} style={{ opacity : info.disable ? 0.5 : 1}}>
    <div styleName='title'>{ info.title || ''}</div>
    <div styleName='action-wrapper'>
      <div styleName='text'>{ info.actionText || '' }</div>
      <i className='iconfont icon-icon-action-arrow' styleName='arrow' />
    </div>
  </div>;
}

export default SettingItem;